import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from 'react-redux';
import { notificationActions } from '../../store/notification';
import { useEffect, useState } from 'react';
import language from '../../store/language';

const Addresses = ({user, setCurrentContentTitle}) => {
    const dispatch = useDispatch();
    const [country, setCountry] = useState("usa")
    useEffect(() => setCurrentContentTitle("Addresses"), []);
    function copyText(text) {
        // Use the Clipboard API to copy the text
        navigator.clipboard.writeText(text).then(function() {
            dispatch(notificationActions.setNotification({show: true, message: "Text copied to clipboard", type: "success"}));
            setTimeout(() => {
                dispatch(notificationActions.setNotification({show: false, message: "", type: ""}))
            }, 4000)
        }).catch(function(error) {
            console.error('Error copying text: ', error);
        });
    }

    return(
        <div className={"addresses-container"}>
            <div className={"addresses-box"}>
                <div className='row'>
                    <div className='col-md-1'></div>
                    <div className='col-md-2'>
                        <div className={`language-country ${country === "usa" ? "selected-country" : ""}`} onClick={() => setCountry("usa")}>
                            <div style={{backgroundImage: "url('https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Flag_of_the_United_States.svg/1200px-Flag_of_the_United_States.svg.png')"}} alt='usa'/>
                        </div>
                    </div>
                    <div className='col-md-2'>
                        <div className={`language-country ${country === "poland" ? "selected-country" : ""}`} onClick={() => setCountry("poland")}>
                            <div style={{backgroundImage: "url('https://aceproject.org/archived-content/root/PL_flag.gif/image_preview')"}} alt='poland'/>
                        </div>
                    </div>
                    <div className='col-md-2'>
                        <div className={`language-country ${country === "greece" ? "selected-country" : ""}`} onClick={() => setCountry("greece")}>
                            <div style={{backgroundImage: "url('https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Greece.svg/600px-Flag_of_Greece.svg.png?20160309091801')"}}></div>
                        </div>
                    </div>
                    <div className='col-md-2'>
                        <div className={`language-country ${country === "turkey" ? "selected-country" : ""}`} onClick={() => setCountry("turkey")}>
                            <div style={{backgroundImage: "url('https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Flag_of_the_United_Arab_Emirates.svg/1200px-Flag_of_the_United_Arab_Emirates.svg.png')"}}></div>
                        </div>
                    </div>
                    <div className='col-md-2'>
                        <div className={`language-country ${country === "china" ? "selected-country" : ""}`} onClick={() => setCountry("china")}>
                            <div style={{backgroundImage: "url('https://cdn.britannica.com/90/7490-004-BAD4AA72/Flag-China.jpg')"}}></div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                </div>
                {country === "china" && <div className={"row"}>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>First name:</p>
                                <div>
                                    <p className={"address-value"}>{user.name_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.name_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Last name:</p>
                                <div>
                                    <p className={"address-value"}>{user.surname_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.surname_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address:</p>
                                <div>
                                    <p className={"address-value"}>大连市甘井子汇达街17号红星国际广场5号楼1416室 GLJY-air {user.user_id}</p>
                                    <ContentCopyIcon onClick={() => copyText(`大连市甘井子汇达街17号红星国际广场5号楼1416室 GLJY-air ${user.user_id}`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Town / City:</p>
                                <div>
                                    <p className={"address-value"}>Dalian (大连)</p>
                                    <ContentCopyIcon onClick={() => copyText("Dalian (大连)")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>District:</p>
                                <div>
                                    <p className={"address-value"}>甘井子区 Ganjingzi</p>
                                    <ContentCopyIcon onClick={() => copyText("甘井子区 Ganjingzi")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>State:</p>
                                <div>
                                    <p className={"address-value"}>Guangdong</p>
                                    <ContentCopyIcon onClick={() => copyText("Guangdong")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Country:</p>
                                <div>
                                    <p className={"address-value"}>China</p>
                                    <ContentCopyIcon onClick={() => copyText("China")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Post Code (Zip):</p>
                                <div>
                                    <p className={"address-value"}>116003</p>
                                    <ContentCopyIcon onClick={() => copyText("116003")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Phone Number 1:</p>
                                <div>
                                    <p className={"address-value"}>13514117874</p>
                                    <ContentCopyIcon onClick={() => copyText("13514117874")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>}

                {country === "usa" && <div className={"row"}>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>First name:</p>
                                <div>
                                    <p className={"address-value"}>{user.name_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.name_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Last name:</p>
                                <div>
                                    <p className={"address-value"}>{user.surname_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.surname_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Phone:</p>
                                <div>
                                    <p className={"address-value"}>646 659-8429</p>
                                    <ContentCopyIcon onClick={() => copyText(`646 659-8429`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address 1:</p>
                                <div>
                                    <p className={"address-value"}>22 Parkway Cir</p>
                                    <ContentCopyIcon onClick={() => copyText("22 Parkway Cir")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address 2:</p>
                                <div>
                                    <p className={"address-value"}>Unit5, {user.user_id}</p>
                                    <ContentCopyIcon onClick={() => copyText(`Unit5, ${user.user_id}`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>State:</p>
                                <div>
                                    <p className={"address-value"}>DELAWARE (DE)</p>
                                    <ContentCopyIcon onClick={() => copyText("DELAWARE (DE)")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Country:</p>
                                <div>
                                    <p className={"address-value"}>USA</p>
                                    <ContentCopyIcon onClick={() => copyText("China")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>City:</p>
                                <div>
                                    <p className={"address-value"}>New Castle</p>
                                    <ContentCopyIcon onClick={() => copyText("New Castle")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Postal Code:</p>
                                <div>
                                    <p className={"address-value"}>19720</p>
                                    <ContentCopyIcon onClick={() => copyText("19720")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>}

                {country === "poland" && <div className={"row"}>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>First name:</p>
                                <div>
                                    <p className={"address-value"}>{user.name_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.name_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Last name:</p>
                                <div>
                                    <p className={"address-value"}>{user.surname_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.surname_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Telephone:</p>
                                <div>
                                    <p className={"address-value"}>534960700</p>
                                    <ContentCopyIcon onClick={() => copyText(`534960700`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address 1:</p>
                                <div>
                                    <p className={"address-value"}>Ul. Jasna 3/2 {user.user_id}</p>
                                    <ContentCopyIcon onClick={() => copyText(`Ul. Jasna 3/2 ${user.user_id}`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Town:</p>
                                <div>
                                    <p className={"address-value"}>Jelenia Gora</p>
                                    <ContentCopyIcon onClick={() => copyText(`Jelenia Gora`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>Centrum:</p>
                                <div>
                                    <p className={"address-value"}>Nerse sp.z.o.o.</p>
                                    <ContentCopyIcon onClick={() => copyText("Nerse sp.z.o.o.")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Country:</p>
                                <div>
                                    <p className={"address-value"}>Poland</p>
                                    <ContentCopyIcon onClick={() => copyText("Poland")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Postal Code:</p>
                                <div>
                                    <p className={"address-value"}>58-500</p>
                                    <ContentCopyIcon onClick={() => copyText("58-500")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>}

                {country === "greece" && <div className={"row"}>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>First name:</p>
                                <div>
                                    <p className={"address-value"}>{user.name_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.name_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Last name:</p>
                                <div>
                                    <p className={"address-value"}>{user.surname_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.surname_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Country:</p>
                                <div>
                                    <p className={"address-value"}>Greece</p>
                                    <ContentCopyIcon onClick={() => copyText(`Greece`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address 1:</p>
                                <div>
                                    <p className={"address-value"}>Deligiorgi 3, Athina {user.user_id}</p>
                                    <ContentCopyIcon onClick={() => copyText(`Deligiorgi 3, Athina ${user.user_id}`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Flat Number:</p>
                                <div>
                                    <p className={"address-value"}>Usdelivery</p>
                                    <ContentCopyIcon onClick={() => copyText("Usdelivery")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>Province:</p>
                                <div>
                                    <p className={"address-value"}>ATTIKI</p>
                                    <ContentCopyIcon onClick={() => copyText("Guangdong")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Town:</p>
                                <div>
                                    <p className={"address-value"}>Athina</p>
                                    <ContentCopyIcon onClick={() => copyText("China")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Post Code (Zip):</p>
                                <div>
                                    <p className={"address-value"}>10437</p>
                                    <ContentCopyIcon onClick={() => copyText("510160")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Telephone:</p>
                                <div>
                                    <p className={"address-value"}>6996814498</p>
                                    <ContentCopyIcon onClick={() => copyText("18588552668")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>}

                {country === "turkey" && <div className={"row"}>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>First name:</p>
                                <div>
                                    <p className={"address-value"}>{user.name_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.name_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Last name:</p>
                                <div>
                                    <p className={"address-value"}>{user.surname_en}</p>
                                    <ContentCopyIcon onClick={() => copyText(user.surname_en)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Phone:</p>
                                <div>
                                    <p className={"address-value"}>+971 567377973 / +971 551578404</p>
                                    <ContentCopyIcon onClick={() => copyText(`+971 567377973 / +971 551578404`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Country:</p>
                                <div>
                                    <p className={"address-value"}>United Arab Emirates</p>
                                    <ContentCopyIcon onClick={() => copyText("United Arab Emirates")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className={"col-md-6 address-column"}>
                        <ul>
                            <li>
                                <p className={"address-label"}>City:</p>
                                <div>
                                    <p className={"address-value"}>Dubai</p>
                                    <ContentCopyIcon onClick={() => copyText("Dubai")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>State/Region:</p>
                                <div>
                                    <p className={"address-value"}>Deira</p>
                                    <ContentCopyIcon onClick={() => copyText("Deira")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address:</p>
                                <div>
                                    <p className={"address-value"}>Al Khabaisi area, warehouse No:1 C/O GLOBAL GT {user.user_id}</p>
                                    <ContentCopyIcon onClick={() => copyText(`Al Khabaisi area, warehouse No:1 C/O GLOBAL GT ${user.user_id}`)} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                            <li>
                                <p className={"address-label"}>Address 2:</p>
                                <div>
                                    <p className={"address-value"}>Opposite ENOC Fuel Station</p>
                                    <ContentCopyIcon onClick={() => copyText("Opposite ENOC Fuel Station")} style={{cursor: "pointer"}}/>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default Addresses